module.exports = __webpack_public_path__ + "static/media/Panama Pictures Logo.85a090ff.jpg";